import React from 'react';

export const Main = props => (
    <div className="main">
        {props.children}
    </div>
);

export default Main;



// WEBPACK FOOTER //
// ./src/components/app/layout/Main.js